export default __webpack_public_path__ + "static/media/pic5.4900c1cc.jpg";